import { createReducer } from '@reduxjs/toolkit'
import ActionTypes from '@constants/action_types.js'
import { mergeEntity, mergeEntities } from '@utils/object.js'

export const initialState = {}

function getDefaultAttributes() {
  return {}
}

export const permission = createReducer(initialState, builder => {
  builder
    .addCase(ActionTypes.RECEIVE_ENTITIES, (state, action) => receiveEntities(state, action))
    .addCase(ActionTypes.PERMISSION_DELETE_SUCCESS, (state, action) => removePermission(state, action))
})

function receiveEntities(state, action) {
  const { payload } = action
  if (payload.hasOwnProperty('permission')) {
    const { permission } = payload
    state = mergeEntity(state, permission, getDefaultAttributes())
  }
  if (payload.hasOwnProperty('permissions')) {
    const { permissions } = payload
    state = mergeEntities(state, permissions, getDefaultAttributes())
  }
  return state
}

function removePermission(state, action) {
  const { payload: id } = action
  const idString = id.toString()
  delete state[idString]
}

export default permission
